import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'rsuite';
import SelectionCell from '../Selection';
import HouseholdMembersCell from '../HouseholdMembersCell';

const { Cell } = Table;

const GuestFieldCell = ({ options, dataKey, ...props }) => {
  if (options) {
    return <SelectionCell dataKey={dataKey} options={options} {...props} />;
  }
  if (dataKey === 'othersHousehold') {
    return <HouseholdMembersCell dataKey={dataKey} {...props} />;
  }
  return <Cell dataKey={dataKey} {...props} />;
};

GuestFieldCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  options: PropTypes.shape({}),
  rowData: PropTypes.shape({})
};

GuestFieldCell.defaultProps = {
  options: null,
  rowData: null
};
export default GuestFieldCell;
